/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import { Accordion, AccordionDetails, AccordionSummary, Box, useTheme, withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CrudTable from '../clients/details/crudTable.component';
import { enumColumn } from 'modules/common/enumTableColumn';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import classNames from 'classnames';
import { deleteInternalUser, getInternalUsers, postInternalUser, putInternalUsers } from 'modules/common/common.actions';
import { DELETE_INTERNAL_USER_FAILURE, GET_INTERNAL_USERS_FAILURE, POST_INTERNAL_USER_FAILURE, PUT_INTERNAL_USER_FAILURE } from 'modules/common/store/types';

const styles = (theme) => {
  return {
    row: {
      backgroundColor: theme.palette.common.white,
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    root: {
      maxWidth: 170,
      marginRight: 10,
    },
    extRoot: {
      width: 115,
      marginRight: 10,
    },
    primaryContactRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
    },
    primaryText: {
      paddingTop: 12,
      paddingRight: 5,
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050,
    },
  };
};

const InternalUsersTable = (props) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const internalUserTypes =
    props.internalUserTypesEnum && props.internalUserTypesEnum.length > 0
      ? props.internalUserTypesEnum.filter(s => s.isActive === true)
      : [];

  const adjustedColumns = [
    { ...enumColumn('internalUserTypeId', internalUserTypes), header: 'Type', type: 'dropdown-v2', options: internalUserTypes, required: false, size: 50 },
    { accessorKey: 'firstName', header: 'First Name', type: 'text', required: false, size: 50 },
    { accessorKey: 'lastName', header: 'Last Name', type: 'text', required: true, size: 70 },
    { accessorKey: 'displayUserName', header: 'Username', type: 'text', required: true, size: 70 },
    { accessorKey: 'emailAddress', header: 'Email', type: 'text', required: true, size: 50 },
    { accessorKey: 'officePhone', header: 'Office Phone', type: 'text', required: true, size: 50 },
    { accessorKey: 'mobilePhone', header: 'Mobile Phone', type: 'text', required: true, size: 50 },
    { accessorKey: 'fax', header: 'Fax', type: 'text', required: true, size: 50 },
  ];

  const updateRow = async (orgRow, newRow) => {
    setIsLoading(true);
    newRow.internalUserId = orgRow.original.internalUserId;

    newRow.addedBy = orgRow.original.addedBy;
    newRow.addedOn = orgRow.original.addedOn;
    newRow.modifiedBy = orgRow.original.modifiedBy;
    newRow.modifiedOn = new Date();

    const checkValues = {
      ...newRow,
    };

    const resp = await props.putInternalUsers(checkValues);
    if (resp.type === PUT_INTERNAL_USER_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getInternalUsers();
      if (getResp.type === GET_INTERNAL_USERS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const createRow = async (values) => {
    setIsLoading(true);
    const checkValues = {
      ...values,
      addedBy: 1,
      addedOn: new Date(),
      modifiedBy: 1,
      modifiedOn: new Date()
    };

    const resp = await props.postInternalUser(checkValues);
    if (resp.type === POST_INTERNAL_USER_FAILURE) {
        setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getInternalUsers();
      if (getResp.type === GET_INTERNAL_USERS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const deleteRow = async (rowToDelete) => {
    setIsLoading(true);
    const id = rowToDelete.original.internalUserId;
    const resp = await props.deleteInternalUser(id);
    if (resp.type === DELETE_INTERNAL_USER_FAILURE) {
      return false;
    } else {
      const getResp = await props.getInternalUsers();
      if (getResp.type === GET_INTERNAL_USERS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  return (
    <Accordion
      expanded={isOpen}
      onChange={() => {
        setIsOpen(!isOpen);
      }}
      classes={{ root: classNames(props.classes.accordionStyleContacts) }}
    >
      <AccordionSummary
        expandIcon={
          <Box color={theme.palette.secondary.main}>
            <ExpandMoreIcon color="inherit" />
          </Box>
        }
      >
        <div className={props.classes.newRow}>
          <h2>Internal Users</h2>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {!isLoading && props.internalUsers && (
          <div>
            <CrudTable
              editingMode={'modal'} // Can be changed to 'row' to edit inline
              columns={adjustedColumns}
              rows={props.internalUsers}
              updateRow={updateRow}
              createRow={createRow}
              deleteRow={deleteRow}
            />
          </div>
        )}
        {isLoading && <Spinner />}
      </AccordionDetails>
    </Accordion>
  );
};

const mapStateToProps = (state) => {
  const { internalUserTypes } = state.enumerations.allEnums;
  const { internalUsers } = state.common;

  return {
    internalUserTypesEnum: internalUserTypes,
    internalUsers: internalUsers
  };
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getInternalUsers,
    putInternalUsers,
    postInternalUser,
    deleteInternalUser
  }),
)(InternalUsersTable);
